import { createFileRoute } from "@tanstack/react-router";

import { AdminBillingActionsPage } from "src/pages/AdminBillingActionsPage";

export const Route = createFileRoute("/_auth/_admin/admin/billing/actions")({
  component: AdminBillingActionsPage,
  ssr: true,
});
